import AppRouter from './router.js';
import ProjectUtil from './utils/project-util.js';
import LazyLoad from './utils/lazyload.js';
import gsap from 'gsap';
import $ from 'jquery';

// app.js
const requiredJSON = {};
const loadedJSON = {};
var fired = false;
const App = {
	init(/*config*/) {
		if (fired) {
			return;
		}
		fired = true;
		ProjectUtil.lazyLoader = new LazyLoad({
			elements_selector: ".lazy-load",
			data_src: "src",
			data_srcset: "srcset",
			callback_load: function (el) {
				// trigger a resize event - make sure the slider doesn't get cut off weirdly
				$(window).trigger('resize');
				gsap.to(el, {
					duration: 0.35, alpha: 1, ease: 'quad.out', onComplete: function () {
						$(window).trigger('resize');
					}
				});
			},
			callback_error: function (el) {
				var $imgWrap = $(el).closest('.img-wrap'),
					regexResult = $imgWrap.length ? $imgWrap[0].className.match(/\bimg_\S+/) : null,
					imgDef = {
						img_thumb: 'default_t.jpg',
						img_square: 'default_sq.jpg',
						img_landscape: 'default_ls.jpg',
						img_portrait: 'default_por.jpg',
						img_profile: 'default_por.jpg',
						img_landscape_thin: 'default_ls_thin.jpg'
					};
				// check for $imgWrap and if it has the class starting with prefix 'img_'
				if (regexResult) {
					$(el).attr('src', 'assets/img/' + imgDef[regexResult[0]]).addClass('loaded');

				} else {
					$(el).attr('src', 'assets/img/default.png').addClass('loaded');
				}
				// trigger a resize event - make sure the slider doesn't get cut off weirdly
				$(window).trigger('resize');
				gsap.to(el, {
					duration: 0.35, alpha: 1, ease: 'quad.out', onComplete: function () {
						$(window).trigger('resize');
					}
				});
			},
		});
		this.defineJSON();
	},

	defineJSON() {
		const ts = new Date().getTime();
		const self = this;
		// GlobalsObj.CMS_JSON _should_ be loaded in index.php.  If not, attempt to load it now.
		if (!window.GlobalsObj.hasOwnProperty('CMS_JSON')) {
			requiredJSON.cms = false;
			ProjectUtil.requestAPI('a=all&language=' + /*cookies.get('language') + */ '&v=' + ts, function (response) {
				// done function
				if (response && response.data) {
					loadedJSON.cms = response.data;
					requiredJSON.cms = true;
					self.buildRouter();
				} else {
					console.error('failed to fetch API data');
					// trigger error message
					self.Router.dataError();
				}

			});
		} else {
			requiredJSON.cms = true;
			loadedJSON.cms = window.GlobalsObj.CMS_JSON;
			this.buildRouter();
		}
	},

	buildRouter() {
		let jsonLoaded = true;

		Object.entries(requiredJSON).forEach(([prop, val]) => {
			if (val === false) {
				jsonLoaded = false;
				console.log(`requiredJSON.${prop} is not loaded`);
			}
		});

		// if some required JSON isn't loaded, exit
		if (!jsonLoaded) {
			console.log('json not loaded');
			return;
		}

		// initialize Router
		AppRouter.initialize(loadedJSON);
	}
};

export default App;